// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PS0vi","container":"Footer_container__LNs8D"};